const RevertIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={20}
      fill="none"
      viewBox="0 0 18 20"
    >
      <path d="M3.26392 15.6668C4.08803 16.9001 5.25937 17.8614 6.62982 18.4291C8.00026 18.9968 9.50826 19.1453 10.9631 18.8559C12.418 18.5665 13.7543 17.8522 14.8032 16.8033C15.8521 15.7544 16.5664 14.418 16.8558 12.9632C17.1452 11.5083 16.9967 10.0003 16.429 8.62988C15.8614 7.25943 14.9001 6.08809 13.6667 5.26398C12.4333 4.43987 10.9833 4.00001 9.49994 4.00001H0.999945M3.99994 7L0.999945 4.00001L3.99994 1.00001" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default RevertIcon;
